<div id="not-found" (click)="goBack()">
    <div class="box">
        <div class="title">
            <h1>صفحه پیدا نشد :(</h1>
        </div>
        <div class="guide">
            <div class="return">
                <p>برای <span> بازگشت </span>کلیک کنید</p>
            </div>
        </div>
    </div>
</div>
